// removed by extract-text-webpack-plugin
module.exports = {"StandardPage":"StandardPage","StandardPage__header":"StandardPage__header","StandardPage__navigation":"StandardPage__navigation","StandardPage__heading-pc":"StandardPage__heading-pc","StandardPage__heading-mb":"StandardPage__heading-mb","StandardPage__main":"StandardPage__main","StandardPage__bottom-navigation":"StandardPage__bottom-navigation","StandardPage__footer":"StandardPage__footer"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/standard-page/styles.css
// module id = 797
// module chunks = 0 1